module.exports = __webpack_public_path__ + "static/proxy-extension-picture-2x-537a34e8726c74ce6d32bf187e71945d.png";